"use client";
import { jsx } from "react/jsx-runtime";
import { Toaster as Toaster$1 } from "sonner";
//#region src/components/ui/toaster.tsx
const GLASS_TOAST = {
	"--normal-bg": "var(--glass-fill-menu)",
	"--normal-border": "var(--glass-rim)",
	"--normal-text": "var(--foreground)",
	"--border-radius": "1rem"
};
function Toaster() {
	return /* @__PURE__ */ jsx(Toaster$1, {
		richColors: true,
		position: "bottom-right",
		style: GLASS_TOAST,
		toastOptions: { classNames: { toast: "backdrop-blur-glass-nav backdrop-saturate-[1.4] reduce-transparency:backdrop-blur-none" } }
	});
}
//#endregion
export { Toaster };
